<template>
  <div id="aside">
    <div id="aside-top-margin" />
    <div id="menu">
      <!-- <router-link to="/notices">
        <i class="fa fa-bell-o" aria-hidden="true"></i><span>공지사항</span>
      </router-link> -->
      <router-link to="/">
        <i class="fa fa-question-circle fa-fw" style="font-size: 40px;"></i><span>코드랩 안내</span>
      </router-link>
      <router-link to="/sections/01">
        <span class="step">01</span><span class="title"> 텍스트 꾸미기</span>
      </router-link>
      <router-link to="/sections/02">
        <span class="step">02</span><span class="title"> 제목, 수평선, 인용구</span>
      </router-link>
      <router-link to="/sections/03">
        <span class="step">03</span><span class="title"> 링크와 이미지</span>
      </router-link>
      <router-link to="/sections/04">
        <span class="step">04</span><span class="title"> 목록과 체크박스</span>
      </router-link>
      <router-link to="/sections/91">
        <i class="fa fa-cubes fa-fw"></i><span class="title"> 연습 : 스터디 모집 공고 </span>
      </router-link>
      <router-link to="/sections/05">
        <span class="step">05</span><span class="title"> 코드, 언어 문법 강조, 표</span>
      </router-link>
      <router-link to="/sections/06">
        <span class="step">06</span><span class="title"> 이모지(emoji)와 뱃지 </span>
      </router-link>
      <router-link to="/sections/07">
        <span class="step">07</span><span class="title"> GFM TMI </span>
      </router-link>
      <!-- <router-link to="/sections/92">
        <i class="fa fa-check-circle fa-fw"></i><span class="title"> 중간 점검</span>
      </router-link> -->
      <router-link to="/cheatsheet">
        <i class="fa fa-table fa-fw"></i><span> 치트시트 (요약)</span>
      </router-link>
      <router-link to="/feedback">
        <i class="fa fa-comments-o fa-fw"></i><span> Feedback &amp; Comments</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "sb-aside",
  data(){
    return {
      debugMode: true
    }
  }
}
</script>

<style>
#aside {
  position: fixed;
  left: 0;
  top: 64px;
  width: 300px;
  height: calc(100% - 64px);
  box-sizing: border-box;
  padding: 10px;
  overflow: hidden;
  overflow-y: auto;
  z-index: 100;
}

#menu>a {
  border-radius: 8px;
  display: block;
  padding: 8px 16px;
  margin-bottom: 8px; 
  color: #777777;
}
#menu>a:hover {
  background: #eeeeee;
}
#menu>a.router-link-exact-active {
  font-weight: bold;
  color: #ffffff;
  background: #42b983;
}

#menu>a .step {
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 18px;
  padding: 4px;
  margin-right: 6px;
  border-radius: 50%;
  font-weight: bold;
  background: #42b983;
  color: #ffffff;
  vertical-align: middle;
}
#menu>a.router-link-exact-active .step {
  color: #42b983;
  background-color: #ffffff;
}

#menu>a .fa {
  line-height: 32px;
  font-size: 36px;
  margin-left: -8px;
  border-radius: 50%;
  color: #42b983;
  vertical-align: middle;
}
#menu>a.router-link-exact-active .fa {
  color: #ffffff;
}

#menu>a .title {
  display: inline-block;
  vertical-align:middle;
}
</style>

